import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Field } from "@/components/common";
import { MODULE_LABELS } from "@/lib/api";
import { LIMITS, SETTING_GROUPS } from "./configSchema";

export function ModulesPanel({ c, set, planMods, planName, trial }) {
  const active = c.usePlan ? planMods : c.modules;
  const toggle = (m) => set({ usePlan: false, modules: active.includes(m) ? active.filter((x) => x !== m) : [...active, m] });
  return (
    <div className="space-y-3" data-testid="cfg-modules-panel">
      <label className="flex items-center justify-between gap-3 rounded-lg border px-4 py-3 text-sm">
        <span><b>Usar os módulos do plano</b><span className="block text-xs text-muted-foreground">{planName ? `Plano ${planName}` : trial ? "Teste grátis: módulos definidos no dia do cadastro" : "Sem plano ativo: todos os módulos liberados"}</span></span>
        <Switch checked={c.usePlan} onCheckedChange={(v) => set(v ? { usePlan: true } : { usePlan: false, modules: planMods })} data-testid="cfg-use-plan-switch" />
      </label>
      <p className="text-xs text-muted-foreground">Ligue ou desligue cada módulo só para este cliente. O preço extra é somado na mensalidade enquanto o módulo estiver ligado.</p>
      <div className="divide-y rounded-lg border">
        {Object.entries(MODULE_LABELS).map(([m, label]) => (
          <div key={m} className="flex flex-wrap items-center gap-3 px-4 py-2.5">
            <Switch checked={active.includes(m)} onCheckedChange={() => toggle(m)} data-testid={`cfg-module-${m}`} />
            <span className="flex-1 text-sm">{label}</span>
            <span className="flex items-center gap-1 text-xs text-muted-foreground">+ R$
              <Input type="number" min={0} step="0.01" value={c.prices[m] ?? ""} onChange={(e) => set({ prices: { ...c.prices, [m]: e.target.value } })} placeholder="0,00" className="h-8 w-24" data-testid={`cfg-price-${m}`} />/mês
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function LimitsPanel({ c, set, plan }) {
  return (
    <div className="space-y-3" data-testid="cfg-limits-panel">
      <p className="text-xs text-muted-foreground">Deixe em branco para usar o limite do plano. Use 0 para sem limite.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {LIMITS.map(([k, label]) => {
          const p = Number(plan?.[`max_${k}`] || 0);
          return (
            <Field key={k} label={label} hint={`Plano: ${p || "sem limite"}`}>
              <Input type="number" min={0} value={c.limits[k] ?? ""} onChange={(e) => set({ limits: { ...c.limits, [k]: e.target.value } })} placeholder={p ? String(p) : "sem limite"} data-testid={`cfg-limit-${k}`} />
            </Field>
          );
        })}
      </div>
    </div>
  );
}

function SettingInput({ k, type, value, onChange }) {
  if (type === "bool") return <Switch checked={!!value} onCheckedChange={onChange} data-testid={`cfg-set-${k}`} />;
  if (Array.isArray(type)) {
    return (
      <select value={value} onChange={(e) => onChange(e.target.value)} className="h-9 rounded-md border bg-transparent px-2 text-sm" data-testid={`cfg-set-${k}`}>
        {type.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    );
  }
  return <Input type="number" min={0} step={type === "int" ? 1 : "0.01"} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="h-9 w-28" data-testid={`cfg-set-${k}`} />;
}

export function SettingsPanel({ c, set, active }) {
  const put = (k) => (v) => set({ settings: { ...c.settings, [k]: v } });
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="cfg-settings-panel">
      {SETTING_GROUPS.map((g) => (
        <div key={g.mod} className="space-y-2 rounded-lg border p-4">
          <p className="flex items-center justify-between text-sm font-semibold">{g.title}{!active.includes(g.mod) && <span className="text-[11px] font-normal text-muted-foreground">módulo desligado</span>}</p>
          {g.fields.map(([k, label, type]) => (
            <div key={k} className="flex items-center justify-between gap-3 text-sm">
              <span className="text-muted-foreground">{label}</span>
              <SettingInput k={k} type={type} value={c.settings[k]} onChange={put(k)} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
